import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
const settings = {
  authority: process.env.VUE_APP_COGNITO_AUTHORITY,
  client_id: process.env.VUE_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.VUE_APP_COGNITO_REDIRECT_URI,
  post_logout_redirect_uri: process.env.VUE_APP_COGNITO_LOGOUT_URI,
  response_type: 'code',
  scope: process.env.VUE_APP_COGNITO_SCOPE || 'openid email',
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: false, monitorSession: false, revokeTokensOnSignout: false,
};
const mgr = new UserManager(settings);
export const CognitoAuth = {
  login(state){ return mgr.signinRedirect({ state }); },
  handleCallback(){ return mgr.signinRedirectCallback(); },
  async logout(){ try{ await mgr.signoutRedirect(); }catch(e){ await mgr.removeUser(); window.location.href = process.env.VUE_APP_COGNITO_LOGOUT_URI || '/'; } },
  getUser(){ return mgr.getUser(); },
  async isAuthenticated(){ const u = await mgr.getUser(); return !!u && !u.expired; },
  async getIdToken(){ const u = await mgr.getUser(); return u ? u.id_token : null; },
  async getAccessToken(){ const u = await mgr.getUser(); return u ? u.access_token : null; },
};
export default CognitoAuth;